var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-1xwjee0",
    "aria-label": "file-warn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.0025 9.99917V7.82626C18.0025 7.29604 17.7914 6.78683 17.4163 6.41167L14.5871 3.58249C14.2119 3.20734 13.7027 2.99625 13.1725 2.99625H5.9975C4.89204 2.99625 3.99667 3.89162 3.99667 4.99708V19.0029C3.99667 20.1084 4.89204 21.0037 5.9975 21.0037H9.99917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0025 7.99833H14.0008C13.4486 7.99833 13.0004 7.55015 13.0004 6.99792V2.99625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 22.0042C14.0158 22.0042 12 19.9883 12 17.5023C12 15.0163 14.0158 13.0004 16.5019 13.0004C18.9889 13.0004 21.0037 15.0163 21.0037 17.5023C21.0037 19.9883 18.9889 22.0042 16.5019 22.0042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5029 17.3352V15.6835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 19.158C16.4569 19.158 16.4198 19.195 16.4208 19.24C16.4208 19.285 16.4579 19.322 16.5029 19.322C16.5479 19.322 16.5839 19.285 16.5839 19.24C16.5839 19.195 16.5479 19.158 16.5019 19.158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileinfo);
export default __webpack_public_path__ + "static/media/fileinfo.0ba01780b1a43c4af34c11d19a38b5ef.svg";
export { ForwardRef as ReactComponent };